<template>
	<div class="voted">
		<StateButtons />
	</div>
</template>

<script>
import StateButtons from '@/components/main/StateButtons'
import session from '@/mixins/session'

export default {
	name: 'Voted',
	methods: {
		async start() {
			const success = await this.$store.dispatch('session/start')
			if (success) this.$router.push({ name: 'Vote' })
		}
	},
	mixins: [session],
	components: {
		StateButtons
	}
}
</script>

<style lang="scss" scoped>
@import '~scss/vars';
@import '~scss/components';

.voted {
	margin: 2rem 0;
}

.btn {
	@include button($blue-48, $white, $blue-48, $blue-98);
}
</style>
